/// <reference types="node" />

module.exports = {
  hooks: (globalThis as any).WebChat.hooks
};
